import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/map';
import {SharedDataService} from './shared-data.service';


@Injectable()
export class DialogflowService {

  private baseURL = 'https://api.dialogflow.com/v1/query?v=20150910';
  private token = ' 47f4f4ab9f4c49ec97709ec057284584';
  private sessionId: number = Math.floor(Math.random() * 9000000000000);

  constructor(private http: HttpClient,
              private sharedDataService: SharedDataService) {
  }

  public sendMessage(query: string) {
    const data = {
      query: query,
      lang: 'fr',
      sessionId: '' + this.sessionId
    };
    return this.http
      .post(this.baseURL, data, {headers: {'Authorization': 'Bearer' + this.token}})
      .map(res => {
        return res;
      });

  }


}



// WEBPACK FOOTER //
// ./src/app/services/dialogflow.service.ts